import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)
export const FORM_CONFIG = formConfig

export const ProvisionDeviceFormSchema = z.object({
  networkCorridor: z.string().min(1, "Network Corridor is required"),
  networkSite: z.string().min(1, "Network Site is required"),
})

export type ProvisionDeviceFormData = z.infer<typeof ProvisionDeviceFormSchema>

export function transformToApiRequest(formData: ProvisionDeviceFormData, deviceNumber: number, deviceProcurementInfoNumber?: number, deviceDeliveryDate?: number) {
  return {
    procurementInfo: {
      deviceNumber,
      deviceProcurementInfoNumber,
      deviceDeliveryDate,
      deviceProcurementStatus: "testing",
    },
    provisioningInfo: {
      deviceNumber,
      networkCorridorNumber: parseInt(formData.networkCorridor),
      networkSiteNumber: parseInt(formData.networkSite),
      deviceProvisioningStatus: "requested",
      deviceProvisionRequestedDate: Math.floor(Date.now() / 1000),
      deviceProvisioningType: "test",
    },
  }
}
